import { Spin } from "antd";
import { useAtomValue } from "jotai";
import { Navigate, useLocation } from "react-router-dom";

import { authReadyAtom } from "@/store/auth";
import { getToken } from "@/utils";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * 路由守卫：等待 bootstrap 完成后校验登录态
 * 页面级权限由 RoutePermissionGuard 负责
 */
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const authReady = useAtomValue(authReadyAtom);
  const location = useLocation();
  const token = getToken();

  if (!authReady) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
